import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} dans {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Livraison',
    [ORDER_METHODS.PICKUP]: 'Retrait',
    [ORDER_METHODS.ON_SITE]: 'Commande à table',
  },
};
